import { PropsWithChildren } from 'react';
import cx from 'classnames';

import { ComponentContent, ComponentsWrapper, CONTENT_SIZES } from 'Layout';

import { CollectionPageHeader } from '../../../vehicleCollection/components/CollectionPageHeader/CollectionPageHeader';
import { SaleDetailsView } from '../../../vehicleCollection/components/SaleDetailsView/SaleDetailsView';
import { SaleSupportModal } from '../../../vehicleCollection/components/SaleSupportModal/SaleSupportModal';

import styles from './PostSaleLayout.scss';

// This component is reused across post-sale experiences to maintain consistent layout
export const PostSaleLayout: React.FC<PropsWithChildren & {
  className?: cx.Argument;
  header?: ReturnType<typeof CollectionPageHeader>;
}> = ({ children, className, header }) => (
  <ComponentsWrapper className={cx(styles.layoutWrapper, className)} data-container="post-sale">
    {header || <CollectionPageHeader />}
    <ComponentContent
      className={styles.contentWrapper}
      maxWidth={CONTENT_SIZES.container}
      paddings={false}
    >
      <ComponentContent
        className={cx(styles.contentBox, styles.main)}
        maxWidth={CONTENT_SIZES.large}
        paddings={false}
        selector="section"
      >
        {children}
      </ComponentContent>
      <ComponentContent
        className={cx(styles.contentBox, styles.aside)}
        maxWidth={CONTENT_SIZES.narrow}
        paddings={false}
        selector="aside"
      >
        <SaleDetailsView />
      </ComponentContent>
    </ComponentContent>
    <SaleSupportModal />
  </ComponentsWrapper>
);
